/* eslint-disable */
import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container } from '@material-ui/core';

import OrdersList from 'src/components/order/OrdersList';
import OrderSearchTools from 'src/components/order/OrderSearchTools';
import { fetchUserOrders, fetchSearchData } from 'src/services/order/orderApi';
import CustomNotifier from 'src/customComponents/Notifier';

const Orders = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [limit, setLimit] = useState(10);
  const [pagination, setPagination] = useState({});
  const [userDetails, setUserDetails] = useState({});
  const [page, setPage] = useState(1);
  const [userdata, setUserData] = useState([]);
  const [input, setInput] = useState('');
  const [snackBar, setSnackBar] = useState({ open: false, message: '' });

  const setSnackBarOpen = (val, msg) => {
    if (snackBar.open === true) setSnackBar({ open: false, message: msg });
    setSnackBar({ open: val, message: msg });
  };

  const filteredData = (data) => {
    setInput(data);
    console.log('data', data);
    if (data === '' || data === null || data === undefined) setIsLoading(true);
    return data;
  };

  const dataLimit = (view) => {
    setIsLoading(true);
    setLimit(view);
  };

  const pageNumber = (pageNum) => {
    setIsLoading(true);
    setPage(pageNum);
  };

  const userData = async (Page, Limit, product_id) => {
    fetchUserOrders(Page, Limit, product_id)
      .then((res) => {
        setPagination(res?.pagination);
        setTableData(res?.tableData);
        setUserDetails(res?.userDetails ? res?.userDetails : {});
        setSnackBarOpen(true, res.message);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        setSnackBarOpen(true, error);
      });
  };

  const searchData = async (Page, Limit, Input, product_id) => {
    /* SUSHANT:: gamail.com username gives CORS error at staging server, adding temp solution to change the gmail.com */
    // eslint-disable-next-line operator-linebreak
    const regexPattern =
      // eslint-disable-next-line no-useless-escape
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // eslint-disable-next-line no-empty
    if (regexPattern.test(Input)) {
      // eslint-disable-next-line no-param-reassign
      Input = Input.replace('gmail.com', 'sushantrshindemail.com');
    }
    fetchSearchData(Page, Limit, Input, product_id)
      .then((res) => {
        setPagination(res?.pagination);
        setTableData(res?.tableData);
        setUserDetails(res?.userDetails);
        setSnackBarOpen(true, res.message);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        setSnackBarOpen(true, error);
      });
  };

  useEffect(() => {
    let userdata= JSON.parse(localStorage.getItem(('user')))
    setUserData(userdata);

    if (isLoading && input.length <= 0) {
      userData(page, limit, userdata.product_id);
    }

    if (input && input.trim().length > 0) {
      const timeoutId = setTimeout(() => {
        searchData(page, limit, input, userdata.product_id);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }

    // return true;
  }, [isLoading, limit, page, input]);

  return (
    <>
      <Helmet>
        <title>Order Management</title>
      </Helmet>
      <CustomNotifier setSnackBarOpen={snackBar.open} message={snackBar.message} />
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <OrderSearchTools filteredData={filteredData} />
          <Box sx={{ pt: 3 }}>
            <OrdersList
              isLoading={isLoading}
              pageNumber={pageNumber}
              dataLimit={dataLimit}
              tableData={tableData}
              pagination={pagination}
              userDetails={userDetails}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Orders;
